import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import styled from "styled-components";
import { ValidationErrorResponse } from "../../services/ValidationError";

interface ServerValidationErrorAlertProps {
  serverFailedValidations?: ValidationErrorResponse;
  wrapperClass?: string;
}

const StyledTextDiv = styled("div")`
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: 700;
`;

function ServerValidationErrorAlert({
  serverFailedValidations,
  wrapperClass,
}: ServerValidationErrorAlertProps) {
  const divRef = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, []);

  if (
    !serverFailedValidations ||
    Object.keys(serverFailedValidations).length === 0
  ) {
    return <></>;
  }

  return (
    <StyledTextDiv className={wrapperClass} ref={divRef}>
      <div className="w-100">
        <Card text="danger" border="danger">
          <Card.Header>
            <strong>ERROR</strong>
          </Card.Header>
          <Card.Body>
            <Card.Subtitle>Datos Inválidos:</Card.Subtitle>
            <div>
              <ul>
                {Array.from(Object.keys(serverFailedValidations)).map(
                  (_key, index) => (
                    <li key={index}>
                      {serverFailedValidations[_key as string]}
                    </li>
                  )
                )}
              </ul>
            </div>
          </Card.Body>
        </Card>
      </div>
    </StyledTextDiv>
  );
}

export default ServerValidationErrorAlert;
